// Core
import React from 'react';
import { useSelector } from 'react-redux';
// Components
import { GeckoRow } from 'ui';
import { Chart } from 'react-google-charts';
import WidgetTotalHeader from '../../../components/WidgetTotalHeader';
import graphColours from 'constants/graphColours';
import '../../Conversations/index.scss';
//logic
import StatsLogic from '../../../Logic/StatsLogic';
import StatsLoader from 'routes/stats/components/StatsLoader';

const TimeSaved = (props) => {
  const botsTimeSavedStats = useSelector(
    (state) => state.statsRoute.botsTimeSaved
  );
  const fetchingStats = useSelector(
    (state) => state.statsRoute.fetchingBotsTimeSaved
  );

  const getStatDate = (stat) => stat.day;
  const data = StatsLogic.aggregateStatsByRange(
    botsTimeSavedStats,
    props.currentPeriod,
    (timeSavedByBots) => {
      const aggregatedData = timeSavedByBots.reduce(
        ([botDuration, totalConversations], timeSavedByDay) => {
          return [
            (botDuration += timeSavedByDay.total_bot_duration),
            (totalConversations += timeSavedByDay.total_conversations),
          ];
        },
        [0, 0]
      );
      return [
        aggregatedData[0],
        StatsLogic.getHumanReadableTooltipString(aggregatedData[0]),
      ];
    },
    getStatDate
  );

  const mergedTotalTimeSaved = data.map(([label, totalTime]) => totalTime);
  const maximum = Math.max(...mergedTotalTimeSaved);
  const unit = StatsLogic.valueBetterAs(maximum);

  //total time saved by bot plus, label-date
  const formattedData = data.map(([label, timeSaved, tooltip]) => [
    label,
    StatsLogic.secondsTo(timeSaved, unit),
    tooltip,
  ]);
  const header = ['Date', '', { type: 'string', role: 'tooltip' }];
  const graphData = [header, ...formattedData];

  const graphOptions = {
    hAxis: {
      title: '',
      minValue: 0,
      slantedText: true,
      format: 'MMM D',
      slantedTextAngle: StatsLogic.getSlantedTextAngleForRange(
        props.currentPeriod
      ),
    },
    vAxis: {
      title: unit.charAt(0).toUpperCase() + unit.slice(1),
      format: '#,###',
      minValue: 0,
      maxValue: 5,
      gridlines: { count: -1 },
    },
    tooltip: { isHtml: true },
    focusTarget: 'category',
    legend: 'none',
    colors: [graphColours.primary],
  };
  //total time saved by bot, without label-date
  const getTotal = (arr) =>
    arr.reduce((acc, [label, value]) => {
      return acc + value;
    }, 0);
  // change data format to match the tooltip
  const total = StatsLogic.getHumanReadableTooltipString(getTotal(data));

  return (
    <div>
      <StatsLoader isLoading={fetchingStats}>
        <GeckoRow>
          <div className="col">
            <WidgetTotalHeader primary={total} showSecondary={false} />
          </div>
        </GeckoRow>
        <GeckoRow>
          <div className="col">
            <Chart
              chartType="ColumnChart"
              data={graphData}
              options={graphOptions}
              graph_id={props.id}
              width="100%"
              height="400px"
            />
          </div>
        </GeckoRow>
      </StatsLoader>
    </div>
  );
};

export default TimeSaved;
